module.exports = __webpack_public_path__ + "static/media/markdown-html-supported-blog.c7fe48e6.md";